import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ButtonVariants = {
  primary: {
    backgroundColor: props => props.theme.colors.darkGray,
    color: props => props.theme.colors.white,
    hoverBg: props => props.theme.colors.black,
  },
  secondary: {
    backgroundColor: 'transparent',
    color: props => props.theme.colors.darkGray,
    hoverBg: props => props.theme.colors.lightGray,
    border: `1px solid ${props => props.theme.colors.darkGray}`,
  },
  accent: {
    backgroundColor: props => props.theme.colors.accent,
    color: props => props.theme.colors.white,
    hoverBg: props => props.theme.colors.accentHover,
  },
};

const ButtonSizes = {
  small: {
    padding: '0.5rem 1rem',
    fontSize: props => props.theme.fontSizes.small,
  },
  medium: {
    padding: '0.75rem 1.5rem',
    fontSize: props => props.theme.fontSizes.medium,
  },
  large: {
    padding: '1rem 2rem',
    fontSize: props => props.theme.fontSizes.large,
  },
};

const StyledButton = styled(motion.button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: ${props => props.theme.borderRadius.medium};
  transition: all ${props => props.theme.transitions.short};
  cursor: pointer;
  box-shadow: ${props => props.theme.shadows.small};
  
  /* Apply variants */
  background-color: ${props => ButtonVariants[props.variant].backgroundColor};
  color: ${props => ButtonVariants[props.variant].color};
  ${props => ButtonVariants[props.variant].border && `border: ${ButtonVariants[props.variant].border};`}
  
  /* Apply sizes */
  padding: ${props => ButtonSizes[props.size].padding};
  font-size: ${props => ButtonSizes[props.size].fontSize};
  
  &:hover {
    background-color: ${props => ButtonVariants[props.variant].hoverBg};
    transform: translateY(-2px);
    box-shadow: ${props => props.theme.shadows.medium};
    ${props => props.variant === 'accent' && `
      box-shadow: 0 0 15px 5px rgba(61, 90, 254, 0.4);
    `}
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: ${props => props.theme.shadows.small};
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
  
  svg {
    margin-right: ${props => props.theme.spacing.xs};
  }
`;

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  onClick,
  type = 'button',
  disabled = false,
  ...props 
}) => {
  return (
    <StyledButton
      type={type}
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      whileTap={{ scale: 0.98 }}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button; 